import { render, staticRenderFns } from "./TrainingListAddNew.vue?vue&type=template&id=53924760&"
import script from "./TrainingListAddNew.vue?vue&type=script&lang=js&"
export * from "./TrainingListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TrainingListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports